import { Link } from "react-router-dom";
import type { MovieItem } from "@/types/movie";

interface MovieCardProps {
  movie: MovieItem;
  className?: string;
}

export default function MovieCard({ movie, className = "" }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className={`group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 ${className}`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 海报`}
          title={`${movie.title} 封面图`}
          className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 top-0 flex items-start justify-between p-2">
          <span className="rounded-md bg-primary-500/90 px-1.5 py-0.5 text-[11px] font-medium text-background-50 backdrop-blur">
            {movie.type === "movie" ? "电影" : "剧集"}
          </span>
          <span className="flex items-center gap-1 rounded-md bg-background-950/70 px-1.5 py-0.5 text-[11px] font-semibold text-accent-300 backdrop-blur">
            <i className="ri-star-fill text-[11px]"></i>
            {movie.rating.toFixed(1)}
          </span>
        </div>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-background-950/80 to-transparent p-2 pt-6">
          <span className="text-[11px] text-background-100">{movie.region} · {movie.year}</span>
        </div>
      </div>
      <div className="flex flex-1 flex-col gap-1.5 p-2.5">
        <h3 className="line-clamp-1 text-sm font-semibold text-foreground-950 group-hover:text-primary-600">
          {movie.title}
        </h3>
        <p className="line-clamp-2 text-xs leading-relaxed text-foreground-600">
          {movie.summary}
        </p>
        <div className="mt-auto flex flex-wrap gap-1 pt-1">
          {movie.genres.slice(0, 3).map((g) => (
            <span
              key={g}
              className="rounded-md bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-900"
            >
              {g}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}